import { t } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';

import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { useAppDispatch } from '../../../../hooks/use-app-dispatch';
import { selectState } from '../../../../selectors';
import { setIsPrepopulated } from '../../../../store/shared-signup';
import { FlexContainerRowInner } from '../../../styled/skylab/page';
import CompanySetupText from './company-setup-text';

// NOTE(Marlene): The font-weight in ConfirmDetailsRow is the same as the skylab font-semibold.
const ConfirmDetailsRow = styled(FlexContainerRowInner)`
  &> *:first-child {
    width: ${(props: {
      forceMobile?: boolean;
    }) => (!props.forceMobile ? 25 : 100)}%;
    font-weight: 600!important; 
    min-width: 100px;
  }
`;

const ConfirmCompanyDetails = () => {
  const {
    sharedSignup: {
      signupForm: { companyName, phone, country, street1, street2, street, city, state, postalCode },
    },
  } = useSelector(selectState);

  const dispatch = useAppDispatch();

  // NOTE(Allie): Because of the Flow type for the signup form, there might only be `street`
  //              Also, `street1` and `street2` could be null
  const streetLine = street1 != null && street2 != null ? `${street1} ${street2}` : street;

  return (
    <Fragment>
      <h1>{t('client.headings.confirm-your-company-details')}</h1>
      <CompanySetupText />
      <button
        type='button'
        className='link flex margin-top-xs margin-bottom-md'
        onClick={() => dispatch(setIsPrepopulated(false))}
        data-ref='esb.company-details.edit-button'
      >
        <SIcon name='edit-pencil' />
        <span className='pad-left-xs align-self-center'>{t('client.buttons.edit')}</span>
      </button>
      <ConfirmDetailsRow>
        <p>{t('client.labels.company-name')}</p>
        <p>{companyName}</p>
      </ConfirmDetailsRow>
      <ConfirmDetailsRow>
        <p>{t('client.labels.phone-number')}</p>
        <p>{phone}</p>
      </ConfirmDetailsRow>
      <ConfirmDetailsRow>
        <p>{t('client.labels.country')}</p>
        <p>{country}</p>
      </ConfirmDetailsRow>
      <ConfirmDetailsRow>
        <p>{t('client.labels.address')}</p>
        <p>{streetLine}</p>
      </ConfirmDetailsRow>
      <ConfirmDetailsRow>
        <p>{t('client.labels.city')}</p>
        <p>{city}</p>
      </ConfirmDetailsRow>
      <ConfirmDetailsRow>
        <p>{t('client.labels.region')}</p>
        <p>{state}</p>
      </ConfirmDetailsRow>
      <ConfirmDetailsRow>
        <p>{t('client.labels.postal-code')}</p>
        <p>{postalCode}</p>
      </ConfirmDetailsRow>
    </Fragment>
  );
};

export default ConfirmCompanyDetails;
